import { organisationConstants } from '../../_constants/organisation.constants';
const initialState = { delete_report_loading : true, delete_report: '', delete_report_error: false};

export function deleteReport(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_DELETE_REPORT:
        return {
            delete_report_loading: true,
            delete_report: '',
            delete_report_error: false
        };
      case organisationConstants.RESPONSE_DELETE_REPORT:
        return {
            delete_report_loading: false,
            delete_report: action.delete_report,
            delete_report_error: false
        };
      case organisationConstants.ERROR_DELETE_REPORT:
        return { 
            delete_report_loading: false,
            delete_report: '',
            delete_report_error: true
        };
      default:
        return state
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/organisation/deleteReport.reducer.js